import type { ReactElement } from "react";
import styles from "./CodeBlock.module.css";

export function CodeBlock({ code }: { code: string }): ReactElement {
  return (
    <pre className={`${styles.pre} pf-scroll`}>
      <code>{code}</code>
    </pre>
  );
}
